module.exports = __webpack_public_path__ + "static/media/search_icon.ac1abeee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/icons/search_icon.svg
// module id = 309
// module chunks = 2